var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.16479 0 0 7.51068 0 16.7724C0 26.0341 7.16479 33.5448 16 33.5448C24.8352 33.5448 32 26.0341 32 16.7724C32 7.51068 24.8352 0 16 0ZM25.9976 16.7896C25.9976 16.7896 25.9976 20.1911 25.5859 21.8313C25.3552 22.7291 24.6799 23.437 23.8235 23.6786C22.2588 24.1103 16 24.1103 16 24.1103C16 24.1103 9.75757 24.1103 8.17651 23.6614C7.32007 23.4199 6.64478 22.7117 6.41406 21.8139C6.0022 20.1911 6.0022 16.7724 6.0022 16.7724C6.0022 16.7724 6.0022 13.3711 6.41406 11.7309C6.64453 10.8331 7.33643 10.1078 8.17651 9.86623C9.74121 9.43448 16 9.43448 16 9.43448C16 9.43448 22.2588 9.43448 23.8235 9.88338C24.6799 10.125 25.3552 10.8331 25.5859 11.7309C26.0142 13.3711 25.9976 16.7896 25.9976 16.7896Z",
    fill: "#2D4040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0068 19.9147L19.2114 16.7724L14.0068 13.6301V19.9147Z",
    fill: "#2D4040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.2ed66de12f68ae370ae86568faded04d.svg";
export { ForwardRef as ReactComponent };